<template>
    <v-card flat color="transparent">
        <v-container fluid>
            <v-row>
                <v-col cols="12">
                    <section-header :title="title" :action="true" class="px-0 mb-4"></section-header>
                    <div class="cliped-carousel-wrapper">
                        <vue-slick-carousel v-bind="sliderSettings">
                            <template v-slot:prevArrow>
                                <v-btn fab color="white" small>
                                    <v-icon>mdi-chevron-left</v-icon>
                                </v-btn>
                            </template>
                            <template v-slot:nextArrow>
                                <v-btn fab color="white" small>
                                    <v-icon>mdi-chevron-right</v-icon>
                                </v-btn>
                            </template>
                            <slot></slot>
                        </vue-slick-carousel>
                    </div>
                </v-col>
            </v-row>
        </v-container>
    </v-card>
</template>
<style scoped>
.slick-prev,
.slick-next {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    z-index: 1;
}

.slick-prev {
    left: -10px;
}

.slick-next {
    right: -10px;
}

.slick-disabled {
    opacity: 0;
    pointer-events: none;
}
</style>
<script>
import VueSlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
export default {
    data: () => ({
        sliderSettings: {
            "dots": false,
            "centerMode": false,
            "centerPadding": "20px",
            "focusOnSelect": false,
            "infinite": false,
            "slidesToShow": 5,
            "slidesToScroll": 5,
            "speed": 500,
            "responsive": [{
                "breakpoint": 1024,
                "settings": {
                    "slidesToShow": 4,
                    "slidesToScroll": 4
                }
            }, {
                "breakpoint": 768,
                "settings": {
                    "slidesToShow": 3,
                    "slidesToScroll": 3
                }
            }, {
                "breakpoint": 540,
                "settings": {
                    "slidesToShow": 2,
                    "slidesToScroll": 2
                }
            }]
        }
    }),
    props: ['title'],
    components: {
        'vue-slick-carousel': VueSlickCarousel
    }
}
</script>